export const APP_ROUTES = {
  login: '/login',
  home: '/',
  settings: '/settings',
  groups: '/groups',
  group: '/groups/:id',
  departments: '/departments',
  questionnaires: '/questionnaires',
  questionnaire: '/questionnaires/:id',
  // Under /manage on purpose: `/assignments/:assignmentId` is where an invitation's
  // "Start" button lands for the person invited, which is a different page with
  // a different audience.
  assignments: '/manage/assignments',
  newAssignment: '/manage/assignments/new',
  assignment: '/manage/assignments/:id',
  // Grading, for people holding training-attempt:approve.
  review: '/review',
  reviewAttempt: '/review/:attemptId',
  // A person's own certificates need a session and no permission; every certificate needs certificate:read.
  certificates: '/certificates',
  allCertificates: '/manage/certificates',
  certificate: '/manage/certificates/:id',
  // The signed-in person's own training, open to anyone with a session.
  myAssignment: '/assignments/:assignmentId',
  attempt: '/assignments/:assignmentId/attempts/:attemptId',
} as const;

export const myAssignmentPath = (assignmentId: string): string => `/assignments/${assignmentId}`;

export const attemptPath = (assignmentId: string, attemptId: string): string =>
  `/assignments/${assignmentId}/attempts/${attemptId}`;

export const reviewAttemptPath = (attemptId: string): string => `${APP_ROUTES.review}/${attemptId}`;

export const certificatePath = (id: string): string => `${APP_ROUTES.allCertificates}/${id}`;

export const groupPath = (id: string): string => `${APP_ROUTES.groups}/${id}`;

export const assignmentPath = (id: string): string => `${APP_ROUTES.assignments}/${id}`;

/** A version is chosen with `?v=<number>`; without it the page opens the one worth working on. */
export const VERSION_PARAM = 'v';

export const questionnairePath = (id: string, version?: number): string =>
  version === undefined
    ? `${APP_ROUTES.questionnaires}/${id}`
    : `${APP_ROUTES.questionnaires}/${id}?${VERSION_PARAM}=${version}`;
